<template lang="html">
  <div>
    <div class="resetinfo_header_top">
      <van-nav-bar
        title="个人信息"
        right-text="修改资料"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"/>
    </div>
    <div class="user_info">
      <van-cell-group>
        <van-field label="绑定手机" v-model="phone" disabled/>
        <van-field label="用户名" v-model="nikename" disabled/>
        <van-field label="真实姓名" v-model="realname" :disabled='disabled'/>
        <van-field label="居住区域" v-model="area" :disabled='disabled' @click='pickArea'/>
        <van-field label="详细地址" v-model="address" :disabled='disabled'/>
        <van-field label="性别" v-model="sex" :disabled='disabled' @click='pickSex'/>
        
        <!-- <van-field label="生日" v-model="birthday" :disabled='disabled'/> -->
        <van-field
          v-model="interest"
          label="兴趣爱好"
          type="textarea"
          rows
          autosize
          :disabled='disabled'
        />
        <van-button type="danger" size="large" v-show="show" @click="postUserInfo">提交</van-button>
      </van-cell-group>

      <div v-show="sexshow">
        <van-picker  :columns="columns" @change="onChange"/>
      </div>
      <div v-show='area_show'>
        <van-area :area-list="areaList"  @confirm="areaConfirm" @cancel="areaCancel"/>
      </div>
    </div>
  </div>
 
</template>

<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
import Qs from 'qs'
import { Cell, CellGroup } from 'vant'
import { Field } from 'vant'
import { Button } from 'vant'
import { Toast } from 'vant'
import { Picker } from 'vant';
import { Area } from 'vant';
import areaList from '@/utils/area'

Vue.use(Area);
Vue.use(Picker);

Vue.use(Toast)
Vue.use(Button)
Vue.use(Field)
Vue.use(Cell).use(CellGroup)
export default {

    data (){
      return{
            nikename: '',
            username: '',
            city: '',
            sex: '',
            // birthday: '',
            phone: '',
            disabled : true,
            formhash:'',
            columns:['保密','男','女'],
            sexshow:false,
            area:'',
            areaList:areaList,
            address:'',
            area_show:false,
            sex_id:0,
            resideprovince:'',
            residecity:'',
            residedist:'',
            interest:'',
            realname:'',
            birthyear:'',
            birthmonth:'',
            birthday:'',
            affectivestatus:'',
            bloodtype:'',
            show: false
      }
    },
    created() {
      this.getUserInfo()
    },
    methods: {
      getUserInfo() {
        utilAxios.get({
          url: '/new_api.php?module=home&mod=spacecp&ac=profile&op=base',
          method: 'GET',
          callback: (res) => {
            console.log(res);
            this.nikename = res.data.space.username
            this.username = res.data.space.realname
            this.city = res.data.space.address
            if(res.data.space.gender=='0'){
              this.sex ='保密'
            }else if(res.data.space.gender=='1'){
              this.sex ='男'
            }else{
              this.sex ='女'
            }
            this.sex_id=res.data.space.gender
            this.phone = res.data.space.mobile
            this.realname=res.data.space.realname
            this.resideprovince=res.data.space.resideprovince
            this.residecity=res.data.space.residecity
            this.residedist=res.data.space.residedist
            this.birthyear=res.data.space.birthyear
            this.birthmonth=res.data.space.birthmonth
            this.birthday=res.data.space.birthday
            this.affectivestatus=res.data.space.affectivestatus
            this.bloodtype=res.data.space.bloodtype
            this.interest = res.data.space.interest
            this.address=res.data.space.address
            this.area=res.data.space.resideprovince+res.data.space.residecity+res.data.space.residedist
          }
        })
      },
      pickSex(){
        this.sexshow=true;
        console.log('ddddd')
      },
      onChange(picker, value, index) {
        this.sex=value;
        this.sex_id=index;
        this.sexshow=false;
      },
      pickArea(){
        this.area_show=true;

      },
      areaConfirm(data){
       
        this.area=''
        data.forEach((item,index)=>{
          if(item.code!=''){
            this.area+=item.name;
          }
          
        })
        this.resideprovince=data[0].name;
        this.residecity=data[1].name;
        this.residedist=data[2].name;
        this.area_show=false;

      },
      areaCancel(){
        this.area_show=false;
      },
      postUserInfo() {
        let params={
            formhash:this.formhash,
            realname:this.realname,
            resideprovince:this.resideprovince,
            residecity:this.residecity,
            residedist:this.residedist,
        
            affectivestatus:this.affectivestatus,
            bloodtype:this.bloodtype,
            interest: this.interest,
            gender:this.sex_id,
            birthyear:this.birthyear,
            birthmonth:this.birthmonth,
            birthday:this.birthday,
            address:this.address,
            profilesubmit:true,
            profilesubmitbtn:true,
            privacy:{
              realname:0,
              residecity:0,
              affectivestatus:0,
              bloodtype:0,
              interest:0,
              gender:0,
              birthday:0,

            },
            
        }
        utilAxios.formpost({
          url: '/new_api.php?module=home&mod=spacecp&ac=profile&op=base',
          method: "POST",
          data: Qs.stringify(params),
          callback: (res) => {
            if (res.data.code == 100) {
              Toast.success(res.data.msg)
              this.disabled = true
              this.show = false
              //this.getUserInfo()
            }else {
              Toast.fail(res.data.msg)
            }
          }
        })
      },
      onClickLeft() {
        this.$router.back(-1)
      },
      onClickRight(){
        this.disabled=false;
        this.show=true;
      }
    }
}
</script>

<style lang="scss" scoped>
  .van-button--large{
    width: 95%;
    height: .44rem;
    line-height: .41rem;
    margin: .1rem;
  }
  .van-picker{
    position:fixed;
    width:100%;
    left:0px;
    bottom:0px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/ResetInfo/ResetInfo.vue